<template>
    <div class="full-width" ref="billDetailDom">
        <el-row :gutter="10">
            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="賬單單號">{{i18n.tkey("lang_bill_id")}}</span> : <span class="info-content">{{obj.CommonRef}}</span>
            </el-col>

<!--            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="賬單類型">{{i18n.tkey("lang_bill_order_type")}}</span> : <span class="info-content">{{orderType}}</span>
            </el-col>-->

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="下單者郵箱">{{i18n.tkey("lang_bill_email")}}</span> : <span class="info-content">{{obj.Email}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="下單者姓名">{{i18n.tkey("lang_bill_username")}}</span> : <span class="info-content">{{obj.Name}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts">
                <span class="info-title" tkey="下單者電話">{{i18n.tkey("lang_bill_tel")}}</span> : <span class="info-content">{{obj.Telephone}}</span>
            </el-col>
            <el-col :span="cols" class="info-parts">
              <span class="info-title" tkey="下單地址">{{i18n.tkey("lang_d_address")}}</span> : <span class="info-content">{{obj.DAddInfo1}}{{obj.DAddInfo2}}{{obj.ShipmentAddress}}</span>
            </el-col>



            <el-col :span="cols" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)|| (!myUtil.isEmpty( obj.PaymentMethod) && obj.Verify == -1)">
                <span class="info-title" tkey="支付方式">{{i18n.tkey("lang_pay_method")}}</span> : <span class="info-content">{{obj.PaymentMethod}}</span>
            </el-col>

            <el-col :span="cols" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)|| (!myUtil.isEmpty( obj.orderState) && obj.Verify == -1)">
                <span class="info-title" tkey="訂單狀態">{{i18n.tkey("lang_bill_state")}}</span> : <span class="info-content">{{orderState}}</span>
            </el-col>
          <el-col :span="cols" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)|| (!myUtil.isEmpty( obj.PaymentVerify) && obj.verify == -1)">
            <span class="info-title" tkey="支付狀態">{{i18n.tkey("lang_pay_state")}}</span> : <span class="info-content">{{orderPayState}}</span>
          </el-col>
            <el-col :span="cols" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)|| (!myUtil.isEmpty( obj.OrderDate) && obj.Verify == -1)">
                <span class="info-title" tkey="下單日期">{{i18n.tkey("lang_order_date")}}</span> : <span class="info-content">{{obj.OrderDate}}</span>
            </el-col>


        </el-row>

        <div class="title-part">
            <span tkey="購買詳情">{{i18n.tkey("lang_buy_detail")}}</span>
        </div>

        <div>
          <div ref="billProductTableDom">
            <el-table :data="obj.boproducts">
              <el-table-column prop="ProductName" :label="i18n.tkey('lang_product_name')" />

              <el-table-column :label="i18n.tkey('lang_unit_price')" >
                <template #default="scope">
                  <div style="">
                    <span>{{ scope.row.Cost }} {{ scope.row.Curr }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column  :label="i18n.tkey('lang_buy_num')" >
                <template #default="scope">
                  <div style="">
                    <span>{{ scope.row.TTLQty }} /{{ scope.row.Unit }}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="date" :label="i18n.tkey('lang_total_price_num')" >
                <template #default="scope">
                  <div style="">
                    <span>{{ scope.row.SubTotal }} {{ scope.row.Curr }}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

      <el-col :span="cols" class="info-parts">
        <span class="info-title" tkey="總金額">{{i18n.tkey("lang_bill_total")}}</span> : <span class="info-content">{{totalNum}}</span>
      </el-col>

      <el-row >
        <el-col :span="8" >
        </el-col>
        <el-col :span="8" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)">
          <el-button v-if="obj.PaymentVerify !== '-1'" type="success" round style="width: 100%" @click="clickPayVerifyBtn(obj,'-1')" >Payment {{i18n.tkey("lang_certifie")}}</el-button>
          <el-button v-if="obj.PaymentVerify === '-1'"  type="info" round style="width: 100%" @click="clickPayVerifyBtn(obj,'0')" >Payment {{i18n.tkey("lang_cancel_certifie")}}</el-button>
        </el-col>
        <el-col :span="8">
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="8" >
        </el-col>
        <el-col :span="8" class="info-parts" v-if="myUtil.isNotEmpty(props.fromdata)">
            <el-button v-if="obj.Verify !== '-1'" type="success" round style="width: 100%" @click="clickVerifyBtn(obj,'-1')" >Order {{i18n.tkey("lang_certifie")}}</el-button>
            <el-button v-if="obj.Verify === '-1'"  type="info" round style="width: 100%" @click="clickVerifyBtn(obj,'0')" >Order {{i18n.tkey("lang_cancel_certifie")}}</el-button>
        </el-col>
        <el-col :span="8">
        </el-col>
      </el-row>

    </div>
</template>

<script setup>
    import {ref, toRef, getCurrentInstance, onMounted, computed, inject} from 'vue'
    import billProductTable from "@/components/shopopee/bill/billProductTable"
    import PaypalButton from "@/components/shopopee/button/paypalButton.vue";
    import PaypalForm from "@/components/shopopee/form/paypalForm.vue";
    import myUtil from "@/util/util";

    const props = defineProps(['obj','fromdata'])
    const emits = defineEmits(["changeOrder","clickVerify" ])

    const { proxy } = getCurrentInstance()

    const i18n = inject("i18n")

    const width = ref(425)
    const cols = ref(24)
    //需要重新付款的订单
    const rePayObj = ref(null)

    const totalNum = computed(() => {
        let curr = "HKD"

        if (null != props.obj.boproducts && props.obj.boproducts.length > 0){
            curr = props.obj.boproducts[0].Curr
        }

        return `${props.obj.TotalSum} ${curr}`
    })

    const orderState = computed(() => {
        let state = i18n.tkey("lang_under_review")  //審核中

        if (props.obj.Verify == -1){
            state = i18n.tkey("lang_completed")
        }else if (props.obj.Verify == 1){
            state = i18n.tkey("lang_refused")
        }

        return state
    })

    const payMethod = computed(() => {
        let name = ""

        if (props.obj.printout == 1){
            name = "paypal"
        }

        return name
    })

    const orderPayState = computed(() => {
        let payState = i18n.tkey("lang_unpaid")

        if (props.obj.PaymentVerify == -1){
            payState = i18n.tkey("lang_paid")
        }

        return payState
    })

    const orderType = computed(() => {
        let type = i18n.tkey("lang_item_1")

        switch (props.obj.japno) {
            case "0":
                type = i18n.tkey("lang_company_auth");
                break;

            case "1":
                type = i18n.tkey("lang_staff_num");
                break;

            case "2":
                type = i18n.tkey("lang_three_shop_exp");
                break;

            case "3":
                type = i18n.tkey("lang_buy_nfc_card");
                break;

            case "4":
                type = i18n.tkey("lang_customer_bill");
                break;
        }

        return type
    })

    function reSubmitOrder(obj){
      let curr = obj.currinorder

      if (null != obj.boproducts && obj.boproducts.length > 0){
        curr = obj.boproducts[0].curr
      }

      rePayObj.value = {
        fromtitle: "shopopee_apply_auth_" + obj.commonref,
        fromnumber: obj.commonref,
        fromamout: obj.totalsum,
        fromcurr: curr
      }
    }

    function clickVerifyBtn(obj,verify){
      emits("clickVerify", obj, verify)
    }

    function clickPayVerifyBtn(obj,verify){
      emits("clickPayVerify", obj, verify)
    }

    function submitComplete(){
      rePayObj.value = null
      setTimeout(() => {
        emits("changeOrder",props.obj.id)
      }, 30000)
    }

    onMounted(() => {
        width.value = proxy.$refs.billDetailDom.offsetWidth

        if (width.value > 768){
            cols.value = 12
        }

    })

</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .title-part {
        text-align: left;
        margin-top: 20px;
        margin-bottom: 10px;
    }

    .info-parts {
        padding: 10px;
        text-align: left;
        font-size: 15px;
    }

    .info-title {
        color: #606266;
    }

    .info-content {
        color: #606266;
    }
</style>